import { Component } from '@angular/core';
import { EntityCrud } from '../../../shared/working/entity-crud/entity-crud';
import { ENTITY_CONFIGS } from '../entity-configs';

@Component({
  imports: [EntityCrud],
  selector: 'app-md-a6aedeb5',
  styleUrl: './md-a6aedeb5.css',
  templateUrl: './md-a6aedeb5.html',
})
export class MdA6aedeb5 {
  readonly config = ENTITY_CONFIGS['a6aedeb5'];
}
